
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quelle est la technique utilisée?`}</em></p>
    <p>{`Celle du
`}<a parentName="p" {...{
        "href": "https://www.infovac.ch/fr/faq/developpement-d-un-vaccin"
      }}>{`virus inactivé`}</a>{`. Dans
cette méthode, on inactive le coronavirus (avec un procédé chimique) pour qu’il
ne puisse plus se reproduire. Quand le vaccin est injecté, il provoque une
réaction de notre système immunitaire qui saura ainsi se défendre contre le
“vrai” virus. Un adjuvant à base d’aluminium a été utilisé pour renforcer cette
réponse.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;